"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSkeleton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Css_1 = require("../Css");
function LoadingSkeleton({ rows = 1, columns = 1, size = "md", randomizeWidths = false, contrast = false, }) {
    const cellArray = [...Array(columns)];
    const rowArray = [...Array(rows)];
    const rowHeight = sizeToPixels[size];
    const rowCells = (rowNumber) => {
        const flexGrowForCell = randomizeWidths ? getRandomizedFlexBasisByRowIndex(rowNumber) : 1;
        return cellArray.map((_, i) => ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.br4
                .add("animation", "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite")
                .add("flexGrow", flexGrowForCell)
                .bgGray300.if(contrast).bgGray700.$ }, `row-${rowNumber}-cell-${i}`)));
    };
    return ((0, jsx_runtime_1.jsx)("div", { "aria-label": "Loading", children: rowArray.map((_, i) => ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.df.gap1.mb1.hPx(rowHeight).$, children: rowCells(i) }, `row-${i}`))) }));
}
exports.LoadingSkeleton = LoadingSkeleton;
/** Create the illusion of random widths by cycling through a list of widths that look nice in order */
function getRandomizedFlexBasisByRowIndex(rowIndex) {
    const randomizedFlexBasisValues = [0.65, 0.8, 0.75, 0.9, 0.8, 0.85, 0.8, 0.95];
    const valueIndex = rowIndex % randomizedFlexBasisValues.length;
    return randomizedFlexBasisValues[valueIndex];
}
const sizeToPixels = {
    sm: 16,
    md: 24,
    lg: 32,
};
